import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Progress } from '@landr/maestro';

const LoaderWrapper = styled.div`
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

interface LoaderProps {
    delay?: number;
    onLoad?: () => void;
    onUnload?: () => void;
}

const Loader: React.FC<LoaderProps> = ({ delay = 500, onLoad, onUnload }) => {
    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsShowing(true);
        }, delay);

        return () => {
            // execute the clearTimeout function when unmounted the component
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
        return () => {
            if (onUnload) {
                onUnload();
            }
        };
    }, [onLoad, onUnload]);

    return (
        <LoaderWrapper role="status">
            {isShowing && <Progress size="lg" />}
        </LoaderWrapper>
    );
};

export default Loader;
